import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { AuthGuardService, CommercialService, UserService } from '@core/services';
import { User } from '@shared/models';

@Component({
  selector: 'app-customer-select',
  templateUrl: './customer-select.component.html',
  styleUrls: ['./customer-select.component.css']
})

export class CustomerSelectComponent implements OnInit, OnDestroy {

  user: any;
  subscription: Subscription;

  @Output() switched: EventEmitter<any> = new EventEmitter();

    constructor(private _userService: UserService,
                private _authGuard: AuthGuardService) {
  }

  ngOnInit() {
    this.subscription = this._userService.getUser().subscribe(user => {
      this.user = user
    });
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  onChange(customerAccountValue) {
    if(localStorage.getItem('customerId')){
      localStorage.removeItem('customerId');
    }
    this._userService.setCustomerIndex(customerAccountValue);
    this._authGuard.getAccountInfo();
    this._authGuard.getCreditCards();
    this.switched.emit(customerAccountValue);
  }

  onRefreshCustomers(event) {
    console.log("refreshing cutsomers");
    this._authGuard.getAccountInfo();
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/customer-select/customer-select.component.ts